import {ITemplate} from '../_interface/full-template';
import {GLOBAL_TEMPLATES_CLINIC_ID} from 'shared/magic';

const mineFilter = (i: ITemplate, guid: string) => i.author.authorId === guid;
const globalFilter = (i: ITemplate) => i.clinicId === GLOBAL_TEMPLATES_CLINIC_ID;
const activeFilter = (i: ITemplate) => i.active;
const inactiveFilter = (i: ITemplate) => !i.active;
const deprecatedFilter = (i: ITemplate) => !i.deprecated;
const inUseFilter = (i: ITemplate) => i.usageCount > 0;
const emptyFilter = (item: ITemplate) => item;
const sort = (a: ITemplate, b: ITemplate) => a.name.localeCompare(b.name);

export const sortFilterTemplatesByMineOthers = (templates: ITemplate[], guid: string): ITemplate[] => {
	const mineFl = (item: ITemplate) => mineFilter(item, guid);
	const mine = templates.filter(mineFl).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	const other = templates.filter(i => !mineFl(i)).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	return [...mine, ...other];
};

export const sortFilterTemplatesByMineOtherInactive = (templates: ITemplate[], guid: string) => {
	if (!templates?.length) return [];
	const mineFl = (item: ITemplate) => mineFilter(item, guid);
	const mine = templates.filter(mineFl).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	const other = templates.filter(i => !mineFl(i)).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	const inactive = templates.filter(inactiveFilter).filter(deprecatedFilter).sort(sort);
	return [...mine, ...other, ...inactive];
};

export const sortFilterClinicTemplates = (templates: ITemplate[]) => {
	if (!templates?.length) return [];
	const globalFl = (item: ITemplate) => globalFilter(item);
	const clinic = templates.filter(t => !globalFl(t)).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	const inactive = templates.filter(inactiveFilter).filter(deprecatedFilter).sort(sort);
	return [...clinic, ...inactive];
};

export const sortFilterGlobalTemplates = (templates: ITemplate[]) => {
	if (!templates?.length) return [];
	const globalFl = (item: ITemplate) => globalFilter(item);
	const global = templates.filter(globalFl).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	const inactive = templates.filter(inactiveFilter).filter(deprecatedFilter).sort(sort);
	return [...global, ...inactive];
};

export const sortFilterTemplatesByOtherInactive = (templates: ITemplate[], guid: string) => {
	if (!templates?.length) return [];
	const mineFl = (item: ITemplate) => mineFilter(item, guid);
	const other = templates.filter(i => !mineFl(i)).filter(activeFilter).filter(deprecatedFilter).sort(sort);
	const inactive = templates.filter(inactiveFilter).filter(deprecatedFilter).sort(sort);
	return [...other, ...inactive];
};

export const sortFilterTemplatesByUsageCountAndActiveStatus = (active: boolean, usage: boolean, templates: ITemplate[]): ITemplate[] => {
	if (!templates?.length) return [];
	if (!active && !usage) return templates;
	return [...templates]
		.filter(usage ? inUseFilter : emptyFilter)
		.filter(active ? activeFilter : emptyFilter);
};
